module.exports = __webpack_public_path__ + "brand-text-2fbfcd4c.svg";